import React, { useState } from "react";
import { Gift, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { subscribeNewsletter } from "../lib/api";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      toast.error("Please enter a valid email");
      return;
    }
    try {
      setBusy(true);
      await subscribeNewsletter(email);
      toast.success("Welcome to the club! Check your inbox for a surprise.");
      setEmail("");
    } catch {
      toast.error("Could not subscribe. Try again.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="bg-[#DD4D2A] text-white">
      <div className="max-w-5xl mx-auto px-4 py-16 md:py-24 text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-white/15 mb-5">
          <Gift className="w-6 h-6" />
        </div>
        <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl font-semibold">
          Want A <span className="italic">Free Gift?</span>
        </h2>
        <p className="mt-4 text-white/85 max-w-xl mx-auto">
          Enter your email to get access to free gifts, special deals and early
          drops from George Venture Brands.
        </p>
        <form
          onSubmit={submit}
          className="mt-8 max-w-md mx-auto flex flex-col sm:flex-row gap-3"
        >
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address"
            className="flex-1 px-5 py-3.5 rounded-full bg-white text-[#1A1410] placeholder:text-[#1A1410]/50 outline-none border border-transparent focus:border-[#1A1410]/20"
          />
          <button
            type="submit"
            disabled={busy}
            className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-[#1A1410] text-white font-semibold uppercase text-sm tracking-wider hover:bg-black transition-colors disabled:opacity-60"
          >
            {busy ? "Sending\u2026" : "Subscribe"}
            <ArrowRight className="w-4 h-4" />
          </button>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
